import React from "react";

/* The drawn icon set, shared by every page that uses the platform look.
   It lived inside Home.js until the footer needed the same strokes. */
/* Inline stroke icons. Drawn rather than pulled from a font so each one can be
   animated on its own -- the paths carry a dash offset the CSS walks back to
   zero when a row becomes the active one (see .win-icon in Home.scss). */
const ICONS = {
  play: <path d="M8 5.5v13l11-6.5-11-6.5z" />,
  check: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.5 12 2.5 2.5 4.5-5" />
    </>
  ),
  file: (
    <>
      <path d="M14 3.5H7.5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V8z" />
      <path d="M14 3.5V8h4.5M9 13h6M9 16.5h4" />
    </>
  ),
  chart: (
    <>
      <path d="M4 20V4M4 20h16" />
      <path d="m7.5 15 3.5-4 3 2.4 4.5-6" />
    </>
  ),
  book: (
    <>
      <path d="M4 5.5A2 2 0 0 1 6 3.5h12v15H6a2 2 0 0 0-2 2z" />
      <path d="M4 18.5A2 2 0 0 1 6 16.5h12v4H6a2 2 0 0 1-2-2z" />
    </>
  ),
  spark: <path d="M12 3.5 13.7 9l5.5 1.7-5.5 1.7L12 18l-1.7-5.6L4.8 10.7 10.3 9z" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  screen: (
    <>
      <rect x="3" y="4.5" width="18" height="12" rx="2" />
      <path d="M8.5 20.5h7M12 16.5v4" />
    </>
  ),
  arrow: <path d="M5 12h13m-5.5-5.5L18 12l-5.5 5.5" />,
  chevron: <path d="m6 9 6 6 6-6" />,
  download: <path d="M12 4v10m0 0 4-4m-4 4-4-4M4.5 18.5h15" />,
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4 4" />
    </>
  ),
  image: (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.6" />
      <path d="m4.5 17 4.5-4.5 3.5 3.5 2.5-2 4.5 4" />
    </>
  ),
  sound: <path d="M5 9.5h3l4-3.5v12l-4-3.5H5zM16 9.5a4 4 0 0 1 0 5M18.5 7a7.5 7.5 0 0 1 0 10" />,
  award: (
    <>
      <circle cx="12" cy="9" r="5.5" />
      <path d="m8.5 13.5-1 7 4.5-2.5 4.5 2.5-1-7" />
    </>
  ),
  flame: <path d="M12 3.5s4.5 4 4.5 8a4.5 4.5 0 0 1-9 0c0-1.6.8-3 1.6-4 .2 1.3 1 2 1.9 2 1.3 0 1.8-1.6 1-6z" />,
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2.4" />
      <path d="m3.6 6.5 8.4 6 8.4-6" />
    </>
  ),
  chat: <path d="M20 13.2a2.5 2.5 0 0 1-2.5 2.5H9l-5 4V6.3A2.5 2.5 0 0 1 6.5 3.8h11A2.5 2.5 0 0 1 20 6.3z" />,
  globe: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c4.5 5 4.5 12 0 17-4.5-5-4.5-12 0-17z" />
    </>
  ),
  phone: <path d="M6.5 3.8h3l1.5 4-2 1.4a12 12 0 0 0 5.8 5.8l1.4-2 4 1.5v3a1.7 1.7 0 0 1-1.9 1.7C11.6 18.6 5.4 12.4 4.8 5.7A1.7 1.7 0 0 1 6.5 3.8z" />,
  pin: (
    <>
      <path d="M12 21s6.5-5.6 6.5-10.3a6.5 6.5 0 1 0-13 0C5.5 15.4 12 21 12 21z" />
      <circle cx="12" cy="10.5" r="2.4" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2.2" />
      <path d="M5.5 15H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v.5" />
    </>
  ),
  lock: (
    <>
      <rect x="4.6" y="10.4" width="14.8" height="9.6" rx="2.4" />
      <path d="M8.2 10.4V7.9a3.8 3.8 0 0 1 7.6 0v2.5" />
      <circle cx="12" cy="15.2" r="1.25" />
    </>
  ),
  eye: (
    <>
      <path d="M2.6 12S6.4 5.9 12 5.9 21.4 12 21.4 12 17.6 18.1 12 18.1 2.6 12 2.6 12z" />
      <circle cx="12" cy="12" r="2.9" />
    </>
  ),
  eyeoff: (
    <>
      <path d="M9.6 6.3A8.6 8.6 0 0 1 12 5.9c5.6 0 9.4 6.1 9.4 6.1a17 17 0 0 1-2.4 3.1" />
      <path d="M6.3 8A17 17 0 0 0 2.6 12S6.4 18.1 12 18.1a8.7 8.7 0 0 0 3.3-.63" />
      <path d="M10 10a2.9 2.9 0 0 0 4 4" />
      <path d="M4 4l16 16" />
    </>
  ),
  logout: (
    <>
      <path d="M14.5 4.5h3a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-3" />
      <path d="M10 8 6 12l4 4M6 12h9.5" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8.6" r="3.6" />
      <path d="M5 19.4a7 7 0 0 1 14 0" />
    </>
  ),
};

/** One icon. `role="img"` only where it carries meaning; decorative ones are hidden. */
const Icon = ({ name, label, className }) => (
  <svg
    className={className}
    data-icon={name}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden={label ? undefined : "true"}
    role={label ? "img" : undefined}
    aria-label={label}
  >
    {ICONS[name] || ICONS.play}
  </svg>
);

export { ICONS };
export default Icon;
